import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-privacy',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="min-h-screen bg-gray-50 py-12 px-6 lg:px-24">
      <div class="max-w-4xl mx-auto bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-12">
        <h1 class="text-4xl font-extrabold text-gray-900 mb-8 border-b border-gray-100 pb-6">Privacy Policy</h1>
        
        <div class="space-y-8 text-gray-700 leading-relaxed">
          <section>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">1. Introduction</h2>
            <p>Welcome to reGenesis. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.</p>
          </section>

          <section>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">2. The Data We Collect</h2>
            <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:</p>
            <ul class="list-disc ml-6 mt-4 space-y-2">
              <li><strong>Technical Data:</strong> includes IP address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform.</li>
              <li><strong>Usage Data:</strong> includes information about how you use our website, products and services.</li>
              <li><strong>Marketing and Communications Data:</strong> includes your preferences in receiving marketing from us and our third parties and your communication preferences.</li>
            </ul>
          </section>

          <section>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">3. How We Use Your Data</h2>
            <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
            <ul class="list-disc ml-6 mt-4 space-y-2">
              <li>Where you have given us clear consent.</li>
              <li>To provide the services you requested.</li>
              <li>Where it is necessary for our legitimate interests.</li>
            </ul>
          </section>

          <section>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">4. Your Data Rights</h2>
            <p>Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, to object to processing, and to withdraw consent.</p>
          </section>

          <section class="mt-12 pt-8 border-t border-gray-100 text-sm text-gray-500">
            <p>Last updated: December 2025</p>
          </section>
        </div>
      </div>
    </div>
  `
})
export class PrivacyPageComponent { }
